// extracted by mini-css-extract-plugin
export var root = "_8Mwh";
export var rootHeading = "_4feL";
export var rootList = "Q0z5";
export var rootListItem = "PLap";
export var rootListItemLink = "p2Xa";